// src/components/KnowledgeGraphView.js
import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import KnowledgeGraphVisualization from './KnowledgeGraphVisualization'; // Assuming correct path
import { networkQueries } from '../repository/graphQueries'; // Import the specific query needed
import { formatDate, formatDateTime } from '../utils';

const KnowledgeGraphView = () => {
    const { neo4jService, clientId } = useOutletContext();

    const [networkData, setNetworkData] = useState({ nodes: [], links: [] });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch network data (adapted from original Dashboard.js's overview load)
    const loadNetworkData = useCallback(async () => {
        if (!neo4jService || !clientId) return;
        setLoading(true); setError(null);
        console.log(`KnowledgeGraphView loading data for client: ${clientId}`);
        try {
            // Using the specific getNetworkData helper from neo4jService if it exists,
            // otherwise run the query directly. Adjust based on your neo4jService.js
            let graphData;
            if (typeof neo4jService.getNetworkData === 'function') {
                graphData = await neo4jService.getNetworkData(clientId);
            } else {
                // Fallback if getNetworkData helper doesn't exist
                const results = await neo4jService.runQuery(networkQueries.networkData, { clientId });
                // Manual processing would be needed here similar to getNetworkData logic
                console.warn("neo4jService.getNetworkData helper not found, manual processing needed or run query directly.");
                // Placeholder: You'd need to adapt the processing logic from neo4jService.js here
                graphData = { nodes: [], links: [] }; // Replace with actual processing
            }
            setNetworkData(graphData ?? { nodes: [], links: [] });
        } catch (err) {
            console.error('Error loading network data:', err);
            setError(err.message);
            setNetworkData({ nodes: [], links: [] });
        } finally {
            setLoading(false);
        }
    }, [neo4jService, clientId]);

    useEffect(() => {
        loadNetworkData();
    }, [loadNetworkData]);

    return (
        <>
            <h2 className="text-xl font-semibold mb-6">Full Knowledge Graph</h2>
            {loading && <div className="text-center py-10">Loading Graph...</div>}
            {error && <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded">Error loading graph: {error}</div>}
            {!loading && !error && networkData.nodes.length > 0 && (
                <div className="bg-white rounded-lg shadow p-4" style={{ height: '600px' }}> {/* Add fixed height or adjust */}
                     <KnowledgeGraphVisualization graphData={networkData} />
                </div>
            )}
             {!loading && !error && networkData.nodes.length === 0 && (
                 <div className="text-center p-10 text-gray-500 bg-white rounded-lg shadow">No graph data loaded or available for this client.</div>
             )}
        </>
    );
};

export default KnowledgeGraphView;